// SPDX-License-Identifier: GPL-3.0-or-later
//
// Each job folder's .txt file is formatted as:
//   <jobUrl>
//   <applyType>
//   <description...>
// Writes happen in store.addApplication; reads happen here.

import type { Application } from '../types';

async function resolveFolder(
  root: FileSystemDirectoryHandle,
  relPath: string,
): Promise<FileSystemDirectoryHandle | null> {
  if (!relPath) return null;
  const parts = relPath.split('/').filter(Boolean);
  let cur: FileSystemDirectoryHandle = root;
  for (const part of parts) {
    try {
      cur = await cur.getDirectoryHandle(part);
    } catch {
      return null;
    }
  }
  return cur;
}

async function findTxtFile(dir: FileSystemDirectoryHandle): Promise<FileSystemFileHandle | null> {
  for await (const [name, handle] of dir.entries()) {
    if (handle.kind !== 'file') continue;
    if (name.toLowerCase().endsWith('.txt')) return handle as FileSystemFileHandle;
  }
  return null;
}

export interface JobTxt {
  jobUrl: string;
  applyType: string;
  description: string;
}

export async function readJobTxt(
  root: FileSystemDirectoryHandle,
  app: Application,
): Promise<JobTxt | null> {
  const folder = await resolveFolder(root, app.folderRelPath);
  if (!folder) return null;
  const fileHandle = await findTxtFile(folder);
  if (!fileHandle) return null;
  const text = await (await fileHandle.getFile()).text();
  const [jobUrl = '', applyType = '', ...rest] = text.split('\n');
  return { jobUrl, applyType, description: rest.join('\n') };
}
